import { tracked } from "@glimmer/tracking";
import { on } from "@ember/modifier";
import { action } from "@ember/object";
import { modifier as modifierFn } from "ember-modifier";
import FKBaseControl from "discourse/form-kit/components/fk/control/base";
import DButton from "discourse/ui-kit/d-button";
import dConcatClass from "discourse/ui-kit/helpers/d-concat-class";

const TYPES = {
  text: "text",
  password: "password",
};

export default class FKControlPassword extends FKBaseControl {
  static controlType = "password";

  @tracked type = TYPES.password;
  @tracked isFocused = false;

  focusState = modifierFn((element) => {
    const focusInHandler = () => {
      this.isFocused = true;
    };
    const focusOutHandler = () => {
      this.isFocused = false;
    };

    element.addEventListener("focusin", focusInHandler);
    element.addEventListener("focusout", focusOutHandler);

    return () => {
      element.removeEventListener("focusin", focusInHandler);
      element.removeEventListener("focusout", focusOutHandler);
    };
  });

  get iconForType() {
    return this.type === TYPES.password ? "far-eye" : "far-eye-slash";
  }

  @action
  handleInput(event) {
    const value = event.target.value === "" ? null : event.target.value;
    this.args.field.set(value);
  }

  @action
  toggleVisibility() {
    this.type = this.type === TYPES.password ? TYPES.text : TYPES.password;
  }

  <template>
    <div
      class={{dConcatClass
        "form-kit__control-password-wrapper"
        (if this.isFocused "is-focused")
      }}
    >
      <input
        aria-describedby={{@field.describedBy}}
        aria-invalid={{if @field.error "true"}}
        autocomplete="new-password"
        class="form-kit__control-password"
        disabled={{@field.disabled}}
        id={{@field.id}}
        name={{@field.name}}
        placeholder={{@field.placeholder}}
        type={{this.type}}
        value={{@field.value}}
        ...attributes
        {{on "input" this.handleInput}}
        {{this.focusState}}
      />

      <DButton
        aria-checked={{eq this.type TYPES.text}}
        class="btn-transparent form-kit__control-password-toggle"
        role="switch"
        @action={{this.toggleVisibility}}
        @icon={{this.iconForType}}
      />
    </div>
  </template>
}
